import { render, staticRenderFns } from "./dialog-floatingbutton.vue?vue&type=template&id=b7f1c926&"
import script from "./dialog-floatingbutton.vue?vue&type=script&lang=js&"
export * from "./dialog-floatingbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports